//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * @class am.TwoStateButton
     * This class implements a two-state button to be displayed on the map: the button can be either in "active"
     * or "inactive" state
     */
    module.TwoStateButton = L.Control.extend({
        // Public properties
        options: {
            position: 'topleft',
            cssClass: '',                     // additional class to be added to the button
            activeStateCallback: undefined,   // callback function which will be called when the button is active and the user clicks on it
            inactiveStateCallback: undefined, // callback function which will be called when the button is inactive and the user clicks on it
            activeStateContentsClass:   '',   // CSS class to be applied to the div inside the button when active
            inactiveStateContentsClass: '',   // CSS class to be applied to the div inside the button when inactive
            activeStateContentsText:   '',    // Textual contents of the div inside the button when active
            inactiveStateContentsText: '',    // Textual contents of the div inside the button when inactive
            activeStateTooltip: '',           // tooltip to be displayed on button hover when the button is active
            inactiveStateTooltip: '',         // tooltip to be displayed on button hover when the button is inactive
            active: true,                     // should the button be in active state when created?
            contentsNextToButton: ''          // HTML contents to be appended to the button's container
        },

        _$button: undefined, // private attribute corresponding to the button (jQuery element)

        /**
         * Function called when adding the button to the map. This function was designed following the recommandations
         * of the Leaflet website.
         *
         * @param {L.Map} map - Leaflet map in which the button should be added
         * @return {HTMLElement} - DOM element corresponding to the button
         */
        onAdd: function(map) {
            // Create the button container
            var $container = $('<div class="am-widget"></div>');

            // Create the button
            var $button = this._$button = $('<button data-toggle="tooltip" title="" class="btn btn-default am-widget-button btn-picto"></button>');
            if (this.options.active) {
                $button.addClass('active-state');
            }
            if (this.options.cssClass !== '') {
                $button.addClass(this.options.cssClass);
            }
            if (this.options.active && this.options.activeStateTooltip !== '') {
                $button.attr('title', this.options.activeStateTooltip);
            } else if (this.options.inactiveStateTooltip !== '') {
                $button.attr('title', this.options.inactiveStateTooltip);
            }

            // Create the div to be displayed inside the button
            var $div = $('<div><span></span></div>');
            if (this.options.active && this.options.activeStateContentsClass !== '') {
                $div.addClass(this.options.activeStateContentsClass);
            } else if (this.options.inactiveStateContentsClass !== '') {
                $div.addClass(this.options.inactiveStateContentsClass);
            }
            if (this.options.active && this.options.activeStateContentsText !== '') {
                $div.html('<span>' + this.options.activeStateContentsText + '</span>');
            } else if (this.options.inactiveStateContentsClass !== '') {
                $div.html('<span>' + this.options.inactiveStateContentsText + '</span>');
            }

            // Assemble all parts
            $button.append($div);
            $container.append($button);
            if (this.options.contentsNextToButton) {
                $container.append(this.options.contentsNextToButton);
            }
            var container = $container.get(0);

            // Prevent interaction with the map when clicking on the button or on the menu
            am.utils.preventMapInteractionOverElement(container);

            // Attach callback to be executed when clicking on the button
            L.DomEvent.on($button.get(0), 'click', this._handleClick, this);

            return container;
        },

        /**
         * Function called when removing the button from the map. This function was designed following the recommandations
         * of the Leaflet website.
         *
         * @param {L.Map} map - Leaflet map from which the button should be removed
         */
        onRemove: function(map) {
            // Restore interaction with the map
            am.utils.restoreMapInteractionOverElement(this._container);

            // Remove callback
            L.DomEvent.off(container, 'click', this._handleClick, this);
        },

        /** 
         * Sets the callbacks to be executed when the user clicks on the button
         *
         * @param {Function} activeStateCallback - Callback to be executed on button click when the button is active
         * @param {Function} inactiveStateCallback - Callback to be executed on button click when the button is inactive
         */
        setClickCallbacks: function(activeStateCallback, inactiveStateCallback) {
            this.options.activeStateCallback = activeStateCallback;
            this.options.inactiveStateCallback = inactiveStateCallback;
        },

        /** 
         * Sets the class of the div inside the button
         *
         * @param {String} activeStateContentsClass - Class of the div inside the button when the button is active
         * @param {String} inactiveStateContentsClass - Class of the div inside the button when the button is inactive
         */
        setContentsClasses: function(activeStateContentsClass, inactiveStateContentsClass) {
            if (this._$button) {
                var $div = this._$button.find('div');
                if (this._$button.hasClass('active-state')) {
                    $div.removeClass(this.options.activeStateContentsClass);
                    $div.addClass(activeStateContentsClass);
                } else {
                    $div.removeClass(this.options.inactiveStateContentsClass);
                    $div.addClass(inactiveStateContentsClass);
                }
            }

            this.options.activeStateContentsClass = activeStateContentsClass;
            this.options.inactiveStateContentsClass = inactiveStateContentsClass;
        },

        /** 
         * Sets the textual contents of the div inside the button
         *
         * @param {String} activeStateContentsText - Textual contents of the div inside the button when the button is active
         * @param {String} inactiveStateContentsText - Textual contents of the div inside the button when the button is inactive
         */
        setContentsTexts: function(activeStateContentsText, inactiveStateContentsText) {
            if (this._$button) {
                var $span = this._$button.find('div span');
                if (this._$button.hasClass('active-state')) {
                    $span.html(activeStateContentsText);
                } else {
                    $span.html(inactiveStateContentsText);
                }
            }

            this.options.activeStateContentsText = activeStateContentsText;
            this.options.inactiveStateContentsText = inactiveStateContentsText;
        },

        /** 
         * Sets the tooltips displayed on button hover
         *
         * @param {String} activeStateTooltip - Tooltip to be displayed on button hover while active
         * @param {String} inactiveStateTooltip - Tooltip to be displayed on button hover while inactive
         */
        setTooltips: function(activeStateTooltip, inactiveStateTooltip) {
            if (this._$button) {
                if (this._$button.hasClass('active-state')) {
                    this._$button.attr('title', activeStateTooltip);
                } else {
                    this._$button.attr('title', inactiveStateTooltip);
                }
            }

            this.options.activeStateTooltip = activeStateTooltip;
            this.options.inactiveStateTooltip = inactiveStateTooltip;
        },

        /**
         * Appends some HTML contents next to the button
         *
         * @param {DOMElement|String|jQuery|Array} contents - Contents to be appended to the button's container
         */
        addHtmlContentsNextToButton: function(contents) {
            if (this._container) {
                $(this._container).append(contents);
            }

            if (this.options.contentsNextToButton) {
                contents = [this.options.contentsNextToButton, contents];
            }
            this.options.contentsNextToButton = contents;
        },

        /**
         * Returns whether the current button is active
         *
         * @return {Boolean} Is the button currently active?
         */
        isActive: function() {
            return this._$button.hasClass('active-state');
        },

        /** 
         * Callback function executed when the user clicks on the button
         *
         * @param {Event} event - Event resulting from the user click on the button
         */
        _handleClick: function(event) {
            var $container = $(this._container);
            var $div = this._$button.find('div');

            if (this._$button.hasClass('active-state')) {
                this._$button.removeClass('active-state');
                if (this.options.inactiveStateTooltip) {
                    this._$button.attr('title', this.options.inactiveStateTooltip);
                }
                $div.removeClass(this.options.activeStateContentsClass);
                $div.addClass(this.options.inactiveStateContentsClass);
                if (this.options.inactiveStateContentsText) {
                    $div.html('<span>' + this.options.inactiveStateContentsText + '</span>');
                }
                this.options.activeStateCallback(event);
            } else {
                this._$button.addClass('active-state');
                if (this.options.activeStateTooltip) {
                    this._$button.attr('title', this.options.activeStateTooltip);
                }
                $div.removeClass(this.options.inactiveStateContentsClass);
                $div.addClass(this.options.activeStateContentsClass);
                if (this.options.activeStateContentsText) {
                    $div.html('<span>' + this.options.activeStateContentsText + '</span>');
                }
                this.options.inactiveStateCallback(event);
            }
        }
    });

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Factory function returning an instance of am.TwoStateButton
     * 
     * @param {Object} options - Same options as for class L.Control, with the additional possibilities:
     *      - 'class': additional CSS class to be added to the button container
     * @return {am.TwoStateButton} - New instance of class am.TwoStateButton
     */
    module.twoStateButton = function(options) {
        return new am.TwoStateButton(options);
    };

    return module;

})(am.utils || {});